export default __webpack_public_path__ + "static/media/Accountdet.a3998532.svg";